import { useEffect, useRef, useState } from "react"
import { useFormikContext } from "formik"

export function useFormResetWatcher(fieldKey: string) {
    const { initialValues, values } = useFormikContext<any>()
    const prevValue = useRef(values[fieldKey])
    const [wasReset, setWasReset] = useState(false)

    useEffect(() => {
        const now = values[fieldKey]
        const initial = initialValues[fieldKey]

        const isReset = prevValue.current !== initial && now === initial

        if (isReset) {
            setWasReset(true)
        }
        prevValue.current = now
    }, [values[fieldKey], initialValues[fieldKey], fieldKey])

    useEffect(() => {
        if (wasReset) {
            const timeout = setTimeout(() => setWasReset(false), 0)
            return () => clearTimeout(timeout)
        }
        return undefined
    }, [wasReset])

    return wasReset
}
